<template>
  <div
    class="navrh-comment"
    :class="{'navrh-comment--compact': compact}"
  >
    <button
      type="button"
      class="navrh-comment-btn text-none"
      @click="toggle"
    >
      <v-icon
        x-small
        left
      >
        rate_review
      </v-icon>
      Připomínka
    </button>
    <v-expand-transition>
      <div
        v-if="open"
        class="navrh-comment-box"
      >
        <div class="caption font-weight-bold mb-1">
          {{ title }}
        </div>
        <v-textarea
          v-model="draft"
          outlined
          dense
          hide-details
          rows="2"
          placeholder="Vaše připomínka…"
        />
        <v-btn
          small
          depressed
          color="primary"
          class="text-none mt-2"
          @click="save"
        >
          Uložit lokálně
        </v-btn>
      </div>
    </v-expand-transition>
    <p
      v-if="note && !open"
      class="caption text--secondary mb-0 mt-1 navrh-comment-preview"
    >
      {{ note }}
    </p>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'NavrhBlockComment',
        props: {
            blockId: {type: String, required: true},
            title: {type: String, required: true},
            note: {type: String, default: ''},
            compact: {type: Boolean, default: false},
        },
        data() {
            return {
                open: false,
                draft: '',
            };
        },
        watch: {
            note: {
                immediate: true,
                handler(v: string) {
                    this.draft = v || '';
                },
            },
        },
        methods: {
            toggle() {
                this.open = !this.open;
            },
            save() {
                this.$emit('update', this.draft.trim());
                this.open = false;
            },
        },
    });
</script>

<style scoped lang="sass">
.navrh-comment
    margin-bottom: 8px

.navrh-comment-btn
    border: 1px dashed #9ec9ee
    background: #fff
    color: #0566c3
    border-radius: 6px
    padding: 4px 10px
    font-size: 12px
    font-weight: 700
    cursor: pointer

.navrh-comment-box
    margin-top: 8px
    padding: 10px
    background: #fff
    border-radius: 8px
    border: 1px solid #e4e9f2

.navrh-comment-preview
    font-style: italic
</style>
